// extracted by mini-css-extract-plugin
export var expandIcon = "d9_tP";
export var rotated = "d9_tQ";